import { styled, Box, Button, Divider } from '@nextiva/next-ui-components';

export const AuthorizeButton = styled(Button)`
  width: 9.313rem;
  height: 2.5rem;
  font-weight: 800;
  font-size: 0.875rem;
  line-height: 1rem;
  & > .MuiSvgIcon-root {
    color: white;
    background: #2fc3a6;
    border-radius: 100%;
    width: 1rem;
    height: 1rem;
    margin-right: 0.5rem;
  }
`;

export const AuthorizedButtonContainer = styled('div')`
  display: flex;
  margin-top: 40px;
`;

export const AuthorizedButton = styled(Box)`
  width: 9.313rem;
  height: 2.5rem;
  font-weight: 400;
  font-size: 0.875rem;
  text-align: center;
  line-height: 3;
  color: #54687f;
  & > .MuiSvgIcon-root {
    color: #2fc3a6;
    border-radius: 100%;
    width: 1rem;
    height: 1rem;
    margin-right: 0.5rem;
  }
`;

export const GoToFive9Button = styled(Button)`
  color: #005fec;
  width: 11.75rem;
  height: 2.5rem;
  font-weight: 800;
  font-size: 0.875rem;
  line-height: 1rem;
  border: 0.063rem solid #005fec;
`;

export const AccordionHeader = styled(Box)`
  display: flex;
  & .five9Header {
    margin-bottom: 0.75rem;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 800;
    font-size: 0.938rem;
    line-height: 1rem;
    letter-spacing: 0.009rem;
    color: #000000;
    & .MuiSvgIcon-root {
      width: 0.75rem;
      height: 1rem;
      color: #6a8099;
      font-size: 0.75rem;
      line-height: 1rem;
      letter-spacing: 0.009rem;
      position: absolute;
      margin: 0rem 0.375rem;
    }
  }
  & .five9SubHeader {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 0.938rem;
    line-height: 1rem;
    letter-spacing: 0.009rem;
    color: #6d829b;
  }
  & .toggleIcon {
    align-self: center;
    & svg {
      font-style: normal;
      font-weight: 900;
      font-size: 0.625rem;
      line-height: 1rem;
      letter-spacing: 0.009rem;
      color: #6d829b;
    }
  }
`;

export const StyledDivider = styled(Divider)`
  margin-top: 1.438rem;
  border-top: 0.031rem solid #8cc6c6;
`;

export const AccordionSummary = styled(Box)`
  margin-top: 2.5rem;
  & .five9ListHeading {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5rem;
    letter-spacing: 0.031rem;
    color: #222648;
  }
  & .five9List {
    margin-top: 1.5rem;
    padding-left: 0.813rem;
    & ul li {
      font-family: 'Lato';
      font-style: normal;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.5rem;
      letter-spacing: 0.031rem;
      color: #222648;
      margin-bottom: 0.625rem;
    }
  }
  & .five9Text {
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5rem;
    letter-spacing: 0.031rem;
    color: #222648;
    padding-right: 10rem;
  }
`;
